<h2 mat-dialog-title>{{title}}</h2>
<mat-dialog-content *ngIf="message" [innerHTML]="message"></mat-dialog-content>
<mat-dialog-actions>
  <button class="btn btn-lg btn-primary btn-block font-weight-bold" mat-dialog-close>{{btnLabel || 'Okay'}}</button>
</mat-dialog-actions>
